/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, {useEffect} from 'react';

import './RadioButton.scss';
import '../SmartDisplay/SmartDisplay.scss'
import {CBForm} from '../../constants/apricotCBform';
import {ADMIN_ROLE} from '../../constants/global';

const Radio = ({RadioRequired, halfInput, radioId, radioName, radioInput, radioValue, onChangeRadioValue, readOnly, org_rol, children}) => {

  useEffect(() => {
    document.querySelectorAll('.cb-radio').forEach(elem => {
      const input = elem.querySelector('input');

      // default value for type parameter is checkbox
      const data = {
        elem: input,
        type: input?.getAttribute('type')
      };

      CBForm.customFormElement(data);
    });
  }, []);

  return (
    <div className={`cb-spacerv-bottom-8 wrapanywhere lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
      {children}
      <label htmlFor={radioId} className='display-flex justify-content-start align-items-center'>
        <input
          id={radioId}
          className='inputClasstest'
          type='radio'
          required={RadioRequired}
          disabled={readOnly}
          aria-readonly={readOnly}
          data-testid='radioid'
          name={radioName}
          onChange={onChangeRadioValue}
          value={radioValue}
          checked={radioInput!==''}
        />
        <span>{radioValue}</span>
      </label>
    </div>
  );
};

export default Radio;